import React from 'react';
import './InstructionItem.css';

const InstructionItem = (props) => {
    return (
        <div>
            <video className='video-container' preload="metadata">
                <source src={props.path + '#t=2'} type={props.type} />
            </video>
            <div className='video-description'>
                {props.name}
            </div>
        </div>
    );
}

export default InstructionItem;